import {
  useTheme,
  Paper,
  Button,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import { IconCloudUpload } from "@tabler/icons-react";
import { useState } from "react";
import { Alert } from "@material-ui/lab";
import FileItemPreview from "../../../components/common/filles/FileItemPreview";

const FileInput = (props: {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}) => {
  const theme = useTheme();
  return (
    <div>
      <input
        onChange={props.onChange}
        accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        id="contained-button-file"
        hidden
        type="file"
        multiple
      />
      <label htmlFor="contained-button-file">
        <Paper
          variant="outlined"
          style={{
            display: "flex",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            border: `2px dashed ${theme.palette.primary.main}`,
          }}
        >
          <div>
            <br />
            <center>
              <IconCloudUpload
                size={60}
                strokeWidth={1}
                color={theme.palette.primary.light}
              />
            </center>
            <center>Seleccione uno o varios archivos</center>
            <br />
          </div>
        </Paper>
      </label>
      <br />
    </div>
  );
};

interface props {
  onSubmit: (files: File[]) => void;
  isLoading: boolean;
  onCancel: () => void;
}
const UploadXlsx = ({ onSubmit, isLoading, onCancel }: props) => {
  const [files, setFiles] = useState<File[]>([]);
  const [isErrorFiles, setIsErrorFiles] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsErrorFiles(false);
    const files = e.target.files;
    if (files === null) return;
    setFiles((values) => [...values, ...Array.from(files)]);
  };

  const handleSubmit = () => {
    setIsErrorFiles(false);
    if (files.length === 0) {
      setIsErrorFiles(true);
      setErrorMessage("Archivos requeridos.");
      return;
    }
    onSubmit(files);
  };

  return (
    <div>
      {files.length > 0 ? (
        <div style={{ paddingBottom: 10 }}>
          {files.map((f, index) => (
            <FileItemPreview
              key={index}
              file={f}
              onClick={(file) => {
                const arrayClone = [...files];
                arrayClone.splice(index, 1);
                setFiles((values) => [...arrayClone]);
              }}
            />
          ))}
        </div>
      ) : (
        <FileInput onChange={handleChange} />
      )}
      {isErrorFiles === true ? (
        <Alert severity="error" style={{ marginBottom: 14 }}>
          {errorMessage}
        </Alert>
      ) : null}

      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Button fullWidth size="large" onClick={onCancel}>
            Cancelar
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            disabled={isLoading || isErrorFiles}
            endIcon={isLoading === true ? <CircularProgress size={20} /> : null}
            fullWidth
            size="large"
            color="primary"
            variant="contained"
            onClick={handleSubmit}
          >
            Subir Archivos
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default UploadXlsx;
